export default __webpack_public_path__ + "static/media/notebook.eb75d1ff.svg";